import { CheckCircle, WarningCircle, CircleNotch } from "@phosphor-icons/react";

const when = (t) => (t ? new Date(t).toLocaleString("pt-PT", { dateStyle: "short", timeStyle: "short" }) : "");

export function ResearchStatus({ c, busy, lastError }) {
  if (busy) {
    return <div className="flex items-center gap-2 rounded-xl border border-primary/30 bg-primary/5 px-4 py-3 text-sm" data-testid="research-status-running"><CircleNotch className="animate-spin" /> A pesquisar no Google Places… (até 30 s)</div>;
  }
  const err = lastError || c.research_error;
  if (lastError?.kind === "info") {
    return <div className="flex items-start gap-2 rounded-xl border border-amber-500/40 bg-amber-50 px-4 py-3 text-sm font-medium text-amber-900" data-testid="campaign-empty-notice"><WarningCircle weight="fill" className="mt-0.5 shrink-0" />{lastError.message}</div>;
  }
  const newerErr = err && (!c.research || !err.at || err.at > c.research.at);
  if (!c.places_configured || newerErr) {
    return (
      <div className="flex items-start gap-2 rounded-xl border border-destructive/30 bg-destructive/5 px-4 py-3 text-sm text-destructive" data-testid="research-status-error">
        <WarningCircle weight="fill" className="mt-0.5 shrink-0" />
        <span>{!c.places_configured ? "Falta a chave Google Places neste ambiente: abra Definições da Prospeção, cole a chave e guarde." : `Pesquisa falhou${err.at ? ` (${when(err.at)})` : ""}: ${err.message}`}</span>
      </div>
    );
  }
  if (!c.research) return null;
  const r = c.research;
  return (
    <div className="flex items-start gap-2 rounded-xl border border-emerald-600/30 bg-emerald-50 px-4 py-3 text-sm text-emerald-900" data-testid="research-summary">
      <CheckCircle weight="fill" className="mt-0.5 shrink-0" />
      <span>
        Última pesquisa ({when(r.at)}): {r.found} encontrados · {r.added} adicionados
        {r.enriched?.length ? ` · ${r.enriched.length} atualizados com dados Google` : ""}
        {r.skipped?.length ? ` · ignorados: ${r.skipped.map((s) => `${s.name} (${s.skipped})`).join(", ")}` : ""}
        {r.limit_reached ? ` · ${r.limit_reached} não entraram porque a campanha chegou ao máximo de ${r.max_results} negócios` : ""}
      </span>
    </div>
  );
}
